import React from 'react';
import { Card, ToggleContainer, OptionalForm, SelectLabel, TooltipHelp } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Style from './display.module.css';

export const getOptions = val => {
    return Object.entries(val).map(([key, value]) => ({
        text: value,
        value: key
    }));
};

const Display = ({ formModuleDisplay, setFormModuleDisplay }) => {
    const { t } = useTranslation();
    const [openOptionalForm, setOpenOptionalForm] = React.useState(
        Boolean(
            formModuleDisplay.aff_quantite ||
                formModuleDisplay.aff_commissions ||
                formModuleDisplay.aff_ht ||
                formModuleDisplay.display_tarif_description ||
                formModuleDisplay.display_list_participants_widget ||
                !formModuleDisplay.display_widget_timer
        )
    );

    const times = {
        '5': '5 ' + t('ticket.ticket_option.module.display.minutes'),
        '6': '6 ' + t('ticket.ticket_option.module.display.minutes'),
        '7': '7 ' + t('ticket.ticket_option.module.display.minutes'),
        '8': '8 ' + t('ticket.ticket_option.module.display.minutes'),
        '9': '9 ' + t('ticket.ticket_option.module.display.minutes'),
        '10': '10 ' + t('ticket.ticket_option.module.display.minutes'),
        '15': '15 ' + t('ticket.ticket_option.module.display.minutes') + ' (' + t('ticket.ticket_option.module.display.recommended') + ')',
        '30': '30 ' + t('ticket.ticket_option.module.display.minutes'),
        '45': '45 ' + t('ticket.ticket_option.module.display.minutes'),
        '60': '60 ' + t('ticket.ticket_option.module.display.minutes')
    };

    const displayListWidget = {
        '1': t('ticket.ticket_option.module.display.participant_list_full'),
        '2': t('ticket.ticket_option.module.display.participant_list_initials')
    };

    const renderTimerSelector = () => {
        if (formModuleDisplay.widget_timer_duration !== '0') {
            return (
                <div className={Style['select-label']}>
                    <SelectLabel
                        key="display_widget_timer"
                        label={t('ticket.ticket_option.module.display.widget_timer_duration')}
                        onChange={change => {
                            setFormModuleDisplay('widget_timer_duration', change);
                        }}
                        options={getOptions(times)}
                        value={formModuleDisplay.widget_timer_duration}
                        useNew
                    />
                </div>
            );
        }
    };

    return (
        <Card.FormStep title={t('ticket.ticket_option.module.display.title')} id={'display'} rightComponent>
            <>
                <ToggleContainer
                    className={Style['toggle-container']}
                    key="aff_date_finvente"
                    checked={formModuleDisplay.aff_date_finvente}
                    title={
                        <>
                            <span>{t('ticket.ticket_option.module.display.end_date')}</span>
                            <TooltipHelp triggerOnHover title={t('ticket.ticket_option.module.display.end_date_tooltip')} />
                        </>
                    }
                    onChange={(synth, { checked }) => {
                        setFormModuleDisplay('aff_date_finvente', checked);
                    }}
                />
                <ToggleContainer
                    className={Style['toggle-container']}
                    key="categories_expanded"
                    checked={formModuleDisplay.categories_expanded}
                    title={
                        <>
                            <span>{t('ticket.ticket_option.module.display.categories_expanded')}</span>
                            <TooltipHelp triggerOnHover title={t('ticket.ticket_option.module.display.categories_expanded_tooltip')} />
                        </>
                    }
                    onChange={(synth, { checked }) => {
                        setFormModuleDisplay('categories_expanded', checked);
                    }}
                />
                <hr className="wz-headercard-separator" />
                <OptionalForm
                    key="optional_form"
                    className={Style['display--optionnal-form']}
                    labelClosed={t('ticket.ticket_option.module.display.close_category')}
                    labelOpen={t('ticket.ticket_option.module.display.open_category')}
                    onToggle={toggle => setOpenOptionalForm(toggle)}
                    open={openOptionalForm}
                >
                    <ToggleContainer
                        className={Style['toggle-container']}
                        key="aff_quantite"
                        checked={formModuleDisplay.aff_quantite}
                        title={
                            <>
                                <span>{t('ticket.ticket_option.module.display.aff_quantite')}</span>
                                <TooltipHelp triggerOnHover title={t('ticket.ticket_option.module.display.aff_quantite_tooltip')} />
                            </>
                        }
                        onChange={(synth, { checked }) => {
                            setFormModuleDisplay('aff_quantite', checked);
                        }}
                    />
                    <ToggleContainer
                        className={Style['toggle-container']}
                        key="aff_commisions"
                        checked={formModuleDisplay.aff_commissions}
                        title={
                            <>
                                <span>{t('ticket.ticket_option.module.display.aff_commissions')}</span>
                                <TooltipHelp triggerOnHover title={t('ticket.ticket_option.module.display.aff_commissions_tooltip')} />
                            </>
                        }
                        onChange={(synth, { checked }) => {
                            setFormModuleDisplay('aff_commissions', checked);
                        }}
                    />
                    <ToggleContainer
                        className={Style['toggle-container']}
                        key="aff_ht"
                        checked={formModuleDisplay.aff_ht}
                        title={
                            <>
                                <span>{t('ticket.ticket_option.module.display.aff_ht')}</span>
                                <TooltipHelp triggerOnHover title={t('ticket.ticket_option.module.display.aff_ht_tooltip')} />
                            </>
                        }
                        onChange={(synth, { checked }) => {
                            setFormModuleDisplay('aff_ht', checked);
                        }}
                    />
                    <ToggleContainer
                        className={Style['toggle-container']}
                        key="aff_tarif_description"
                        checked={formModuleDisplay.display_tarif_description}
                        title={
                            <>
                                <span>{t('ticket.ticket_option.module.display.display_tarif_description')}</span>
                                <TooltipHelp triggerOnHover title={t('ticket.ticket_option.module.display.display_tarif_description_tooltip')} />
                            </>
                        }
                        onChange={(synth, { checked }) => {
                            setFormModuleDisplay('display_tarif_description', checked);
                        }}
                    />
                    <ToggleContainer
                        className={Style['toggle-container']}
                        key="display_list_participant_widget_toggle"
                        checked={formModuleDisplay.display_list_participants_widget > 0}
                        toggle={formModuleDisplay.display_list_participants_widget > 0}
                        title={
                            <>
                                <span>{t('ticket.ticket_option.module.display.display_list_participants_widget')}</span>
                                <TooltipHelp triggerOnHover title={t('ticket.ticket_option.module.display.display_list_participants_widget_tooltip')} />
                            </>
                        }
                        onToggle={value => {
                            setFormModuleDisplay('display_list_participants_widget', value ? 1 : 0);
                        }}
                    >
                        <div className={Style['select-label-participants-list']}>
                            <SelectLabel
                                key="display_list_participants_widget"
                                options={getOptions(displayListWidget)}
                                value={`${formModuleDisplay.display_list_participants_widget}`}
                                onChange={(value, opt) => {
                                    setFormModuleDisplay('display_list_participants_widget', parseInt(value));
                                }}
                                useNew
                            />
                        </div>
                    </ToggleContainer>
                    <ToggleContainer
                        className={Style['toggle-container']}
                        key="display_widget_timer_toggle"
                        checked={formModuleDisplay.display_widget_timer}
                        title={
                            <>
                                <span>{t('ticket.ticket_option.module.display.display_widget_timer')}</span>
                                <TooltipHelp triggerOnHover title={t('ticket.ticket_option.module.display.display_widget_timer_tooltip')} />
                            </>
                        }
                        onChange={(synth, { checked }) => {
                            if (checked) {
                                setFormModuleDisplay('widget_timer_duration', '15');
                            } else {
                                setFormModuleDisplay('widget_timer_duration', '0');
                            }

                            setFormModuleDisplay('display_widget_timer', checked);
                        }}
                    />
                    {renderTimerSelector()}
                </OptionalForm>
            </>
        </Card.FormStep>
    );
};

Display.propTypes = {
    formModuleDisplay: PropTypes.object.isRequired,
    setFormModuleDisplay: PropTypes.func.isRequired
};

export default Display;
